import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { useQuery } from 'react-query';
import { SortDirection, SortCriterion } from '../ListSortOptions';
import { Grid } from 'semantic-ui-react';
import { LinearGauge } from '../LinearGauge';
import { GradeDisplay } from '../GradeDisplay';
import { muniname, sentence, ssblnk } from '../../../utils';
import * as API from '../../API';
import './KeyfigureList.scss';
export const KeyfigureList = ({ className, knr, sec, sortCriterion, sortDirection, listElement }) => {
    var _a, _b;
    const { data: sectorResultsData } = useQuery(`kb/kommuner/sektorresultater/${knr}/${sec}`, () => API.fetchMunicipalitySectorResults(knr, sec));
    const { data: municipalityListData } = useQuery('kb/kommuner', () => API.fetchMunicipalityList());
    const selectedMunicipality = municipalityListData
        ? municipalityListData[knr]
        : null;
    const sectorResultRef = useRef(null);
    if (sectorResultsData === null || sectorResultsData === void 0 ? void 0 : sectorResultsData[sec]) {
        sectorResultRef.current = sectorResultsData[sec];
    }
    const clsx = [
        className !== null && className !== void 0 ? className : '',
        'keyfigure-list'
    ].join(' ');
    const allKfg = (_b = (_a = sectorResultRef.current) === null || _a === void 0 ? void 0 : _a.nokkeltall.alle) !== null && _b !== void 0 ? _b : [];
    // So that key figures will be sorted by labels by default, on equal sort criteria
    const defaultSort = (kfgA, kfgB) => {
        return sortDirection === SortDirection.asc
            ? kfgA.etikett.localeCompare(kfgB.etikett, 'no-NO')
            : kfgB.etikett.localeCompare(kfgA.etikett, 'no-NO');
    };
    const keyfigSort = (kfgA, kfgB) => {
        if (sortCriterion === SortCriterion.label) {
            return 0; // Default order, items are already sorted
        }
        const NaN = sortDirection === SortDirection.desc ? -9999 : 9999; // Missing keyfigures always at bottom
        const a = sortCriterion == SortCriterion.weight ? kfgA.vekting : kfgA.tidsserie[0].rangering;
        const b = sortCriterion == SortCriterion.weight ? kfgB.vekting : kfgB.tidsserie[0].rangering;
        return sortDirection === SortDirection.desc ? (b !== null && b !== void 0 ? b : NaN) - (a !== null && a !== void 0 ? a : NaN) : (a !== null && a !== void 0 ? a : NaN) - (b !== null && b !== void 0 ? b : NaN);
    };
    const toggleAboutText = (e) => {
        const aboutWrapper = e.currentTarget.parentElement;
        if (!aboutWrapper)
            return;
        const isActive = aboutWrapper.classList.contains('active');
        if (isActive) {
            aboutWrapper.style.maxHeight = `${aboutWrapper.scrollHeight}px`;
            requestAnimationFrame(() => {
                aboutWrapper.style.maxHeight = '0px';
            });
            aboutWrapper.classList.remove('active');
        }
        else {
            aboutWrapper.classList.add('active');
            aboutWrapper.style.maxHeight = `${aboutWrapper.scrollHeight}px`;
        }
    };
    const sumWeights = allKfg.reduce((acc, kfg) => acc + kfg.vekting, 0);
    const jsxKeyfigures = allKfg.sort(defaultSort).sort(keyfigSort).map((kf) => {
        var _a;
        const v = kf.tidsserie[0];
        const fileArchiveLink = selectedMunicipality
            ? _jsxs("p", { children: ["I ", _jsx("a", { href: `#kommuner/${selectedMunicipality.kommune_knr}/filarkiv`, children: "filarkivet" }), " finner du utregninger, formler og flere detaljer for ", muniname(selectedMunicipality), "."] })
            : null;
        return (_jsx("li", { className: "keyfigure", children: _jsxs(Grid, { stackable: true, children: [_jsxs(Grid.Column, { width: 8, children: [_jsxs("h3", { children: [_jsx("span", { className: "label", children: kf.etikett }), kf.tidsserie[0].rangering ? `#\u2009${v.rangering}` : _jsx("em", { children: "Mangler" })] }), _jsx("h4", { children: kf.beskrivelse }), _jsx(LinearGauge, { compact: true, label: v.aar, value: v.rangering, max: 357, inverted: true, ranking: true }), _jsxs("dl", { className: "grade", children: [_jsxs("dt", { children: ["Karakter: ", kf.tidsserie[0].karakter ? `(\u2009${kf.tidsserie[0].karakter}\u2009)` : '\u2009-\u2009'] }), _jsx("dd", { children: _jsx(GradeDisplay, { value: kf.tidsserie[0].karakter }) })] }), _jsxs("dl", { className: "value", children: [_jsx("dt", { children: "Verdi:" }), _jsxs("dd", { children: [(_a = kf.tidsserie[0].verdi) !== null && _a !== void 0 ? _a : ' - ', kf.enhet === 'prosent' ? `\u2009%` : ` (\u2009${kf.enhet}\u2009)`] })] }), _jsxs("dl", { className: "weight-total", children: [_jsx("dt", { children: "N\u00F8kkeltallvekt:" }), _jsx("dd", { children: kf.vekting ? `${Math.round(kf.vekting * 1000) / 10}%` : ' - ' })] }), _jsxs("dl", { className: "weight-sector", children: [_jsx("dt", { children: "Vekt i sektoren:" }), _jsx("dd", { children: kf.vekting ? `${Math.round(((kf.vekting / sumWeights)) * 100)}%` : ' - ' })] })] }), _jsx(Grid.Column, { width: 8, verticalAlign: "bottom", children: _jsxs("div", { className: "about-box", children: [_jsx("a", { className: "chevron", onClick: toggleAboutText }), _jsxs("div", { className: "about", children: [_jsx("h5", { children: "Om n\u00F8kkeltallet" }), _jsxs("p", { children: [ssblnk(kf.lang_beskrivelse), " ", sentence(kf.tolkning)] }), fileArchiveLink] })] }) })] }) }, `allkfg_${kf.etikett}`));
    });
    return (_jsx("ul", { className: clsx, ref: listElement, children: jsxKeyfigures }));
};
